import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map} from 'rxjs';

import { GlobalFunctionsService } from './../../../services/global-functions.service';

@Component({
  selector: 'app-edit-job',
  templateUrl: './edit-job.component.html',
  styleUrls: ['./edit-job.component.css']
})
export class EditJobComponent implements OnInit {

  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  job: Object;
  JobStep2ID: any;
  model: any;
  job_types: Object;
  job_type_locations: Object;
  count2: any;
  job_type_courts: Object;
  sent_job_type_location_id: any;
  job_type_document_types: Object;
  sent_job_type_court_id: any;
  job_type_affidavit_types: Object;
  sent_job_type_document_type_id: any;
  clients: Object;
  client_contacts: Object;
  sent_client_id: any;
  positionsMysql: any;
  get_subjects: Object;
  job_subject_types: Object;
  job_plaintiff_types: Object;
  sessionUsername: any;
  brands: Object;
  brand_users: Object;
  sent_brand_id: any;
  brand_report_selected: any;
  selected_brand_data: any;
  new_special_instuctions: any;
  special_instructions: any;
  job_id: number;

  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public gfunc: GlobalFunctionsService) {

      this.nav = document.querySelector('nav.navbar');
     

    // login vars
    this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
    console.log('sessionUserId: ', this.currentUserVAR.user_id );
    console.log('sessionUsername: ', this.currentUserVAR.username );
    // Set loggind in User Value (USER ID)
    this.sessionUserId = this.currentUserVAR.user_id;
    this.sessionUsername = this.currentUserVAR.username;
    this.sessionBrandId = this.currentUserVAR.brand_id;
    this.job_id = +this.route.snapshot.paramMap.get('job_id');
    this.JobStep2ID = +this.route.snapshot.paramMap.get('job_id');
      }

  ngOnInit() {
/*     this.JobStep2ID = +this.route.snapshot.paramMap.get('job_id');

   this.getJob(this.JobStep2ID);
    // this.model.job_type_location_id = this.job.job_type_location_id;
    this.getJobTypes();
    this.getPositions();
    this.getClients();
    this.getJobSubjectTypes();
    this.getJobPlaintiffTypes();
    this.getBrands(); */
    
   // this.getJobTypeLocations(this.model.job_type_location_id); // loads default locations as nothing
  }
  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        let res = data[0];
      // Need to load the drop downs (only if a process is selected.)
      this.getJobTypeLocations(res.job_type_id);
      this.getJobTypeCourts(res.job_type_location_id);
      this.getJobTypeDocumentTypes(res.job_type_court_id);
      this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
      // need to load client contact
      this.getClientContactsSharmans(res.client_id);
      
      this.getBrandUsers(res.brand_report_id);
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
  // BOF SHARMANS CALLS
  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
       data => { this.job_subject_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
       data => { this.job_plaintiff_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
  
  
  
   console.log('sending Count:' + this.count2);
  }
  
  
  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
  
  
  
   console.log('sending Location:' + this.sent_job_type_location_id);
  }
  
  
  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
       data => { this.job_type_document_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
  
  
   console.log('sending Court Type:' + this.sent_job_type_court_id);
  }
  
  
  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
       data => { this.job_type_affidavit_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....
  
   console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }
  
  
  
  getClients() {
    this._demoService.getClients().subscribe(
       data => { this.clients = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getClientContactsSharmans(client_id) {
    this._demoService.getClientContactsSharmans(client_id).subscribe(
       data => { this.client_contacts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   sendClientID(client_id) {
   this.sent_client_id = client_id;
   this.getClientContactsSharmans(this.sent_client_id); // updates the selected job ID....
  
   console.log('sending Client ID:' + this.sent_client_id);
  }
  
  private getPositions() {
    this._demoService.getPositions()
      .subscribe(
        res => this.positionsMysql = res,
        err => console.error(err.status)
      );
  }
  
  
  
  // update was here for onit but moved for onchange
  updateJobAll(model) {
    model.updated_by = this.sessionUserId;
    this._demoService.updateJobAll(model).subscribe(
       data => { // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Job Updated');
     //  this.createJobSubjectsMultiple(model);
       // Subject to reload the manager component parent.
      // TraceCandidateManagerComponent.returned.next(false);
     // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
      this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

                 return true;
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error saving Job!');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
  );
  }
  
  
  
  // create subjects
  createJobSubjectsMultiple(model) {
  
     this._demoService.createJobSubjectsMuliple(model).subscribe(
        data => {  this.get_subjects = data; // this is the retuned json upon creation.
        this.toastr.success('Subjects Saving...');
        // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}
  
         // Setup annd the Currents before we redirec the page
         // Needs to be a Function to update the ObserveOnOperator.
         // this.newCTrace_id(this.latest_trace_id);
         // or this.cdata.changeCTrace_id("999");
   
        // this.router.navigate(['/admin/jobs/create-job-2/' + model.job_id + '']);
   
           return true;
   
   
        },
        error => {
        // console.log('Should be form Model' + model);
        // console.error('Error Creating a Trace Project!');
         // this.toastr.error('Adding Subjects Failed :: Please try again!');
         // console.log(Observable.throw(error));
         // return Observable.throw(error);
        }
   );
  }
  
  getBrands() {
    this._demoService.getBrands().subscribe(
       data => { this.brands = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getBrandUsers(brand_report_user_id) {
    this._demoService.getBrandUsers(brand_report_user_id).subscribe(
       data => { this.brand_users = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   sendBrandID(brand_report_user_id) {
   this.sent_brand_id = brand_report_user_id;
   this.getBrandUsers(this.sent_brand_id); // updates the selected job ID....
  // need to look up what brands notes are and send to jon notes.
  // lookup brand
  this.getBrandById_instructions(this.sent_brand_id); // sets the model special instuctions in function
  
   //console.log('sending Brand ID:' + this.sent_brand_id);
  }
  
  getBrandById_instructions(brand_id){
    this._demoService.getBrandById(brand_id)
    .subscribe(
      res => {this.brand_report_selected = res;
        this.selected_brand_data = res[0];
       this.new_special_instuctions = this.selected_brand_data.brand_notes;
       this.special_instructions = this.new_special_instuctions;
       console.log('instructions: ' + this.new_special_instuctions);
     
      },
      err => console.error(err.status)
    );
   }



  
  }
  
    // Allows formatting of dates etc...
    export class DatePipeComponent {
      today: number = Date.now();
      fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
    // tslint:disable-next-line:eofline
    }
  